import { cn } from '@/lib/utils';
import { Label } from '@/shared/components/ui/label';
import GeneralInput from '../../GeneralInput/GeneralInput';
import PasswordInput from '../../PasswordInput/PasswordInput';
import Select from '../../Select/Select';

import type { DetailModalProps } from './DetailModal.types';

const DetailModal = ({
  label,
  inputType,
  value,
  className,
  disabled,
  onChange,
  optionSelect = [],
  required = false,
  name,
  maxLength,
  readonly,
  isDob,
  modalType,
  pattern,
}: DetailModalProps) => {
  return (
    <div className={cn('flex flex-col gap-2 m-1', className)}>
      <Label
        className={cn(
          'text-base text-[#6b7280] dark:text-text-white',
          modalType === 'forgot' && 'font-bold'
        )}
      >
        {label}
        {required && <span className="text-[#e31616]">*</span>}
      </Label>

      {inputType === 'select' ? (
        <Select
          options={optionSelect}
          value={value}
          name={name}
          disabled={disabled}
          onChange={onChange}
          disableEmptyOption={true}
          className={cn(
            modalType === 'forgot' ? 'w-full input-modal-forgot' : 'w-full',
            'text-[#6b7280] dark:text-text-white!'
          )}
        />
      ) : inputType === 'password' ? (
        <PasswordInput
          name={name}
          value={value}
          required={required}
          customInput="flex flex-col gap-2 w-full"
          disabled={disabled}
          onChange={onChange}
          maxLength={maxLength}
          inputFormStyle={cn(
            modalType === 'forgot' && 'input-modal-forgot',
            'text-[#6b7280] dark:text-text-white!'
          )}
        />
      ) : (
        <GeneralInput
          type={inputType}
          name={name}
          value={value}
          required={required}
          customInput="flex flex-col gap-2 w-full"
          disabled={disabled}
          onChange={onChange}
          maxLength={maxLength}
          readonly={readonly}
          isDob={isDob}
          pattern={pattern instanceof RegExp ? pattern.source : pattern}
          inputFormStyle={cn(
            modalType === 'forgot' && 'input-modal-forgot',
            'text-[#6b7280] dark:text-text-white!'
          )}
        />
      )}
    </div>
  );
};

export default DetailModal;
